// import { api } from '../helpers/api_helper';

// const BASE_URL = '/dev/v1'; // Replace with your base URL

// export const fetchData = async (endpoint, data = null, method) => {
//     try {
//         let response;

//         if (method === 'post') {
//             response = await api.create(`${BASE_URL}${endpoint}`, data); // POST request with data
//         } else {
//             const response = data
//             ? await api.create(`${BASE_URL}${endpoint}`, data)
//             : await api.get(`${BASE_URL}${endpoint}`);
//         }
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching data:', error);
//         throw error;
//     }
// };
import { API_ENDPOINTS } from '../constants/apiEndPoints';
import { api } from '../helpers/api_helper';

const BASE_URL = API_ENDPOINTS.BASE_URL; // Replace with your base URL

export const fetchData = async (endpoint, data = null , method) => {
    try {
        if (method === 'post') {
            const response = await api.create(`${BASE_URL}${endpoint}`)
            return response.data;
        }
        else {
            const response = data
                ? await api.create(`${BASE_URL}${endpoint}`, data)
                : await api.get(`${BASE_URL}${endpoint}`);
                return response.data;
        }
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};